export { default } from './svg/lock-fill.svg';
